import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=10ff4b89&scoped=true"
import script from "@/views/Users/Users.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Users.ts?vue&type=script&lang=ts&external"
import style0 from "./users.scss?vue&type=style&index=0&id=10ff4b89&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff4b89",
  null
  
)

export default component.exports